import axios from 'axios'
import { apiGatewayRequestSettings } from '../utils/apiGateway'

// options is an object that will accept 'zip' and 'searchWithinAP'
export const getAvailableOrgs = async (suggestion, options = {}) => {
  try {
    const searchTerm = Number.isNaN(parseInt(suggestion, 10))
      ? `name=${suggestion}`
      : `aicode=${suggestion}`
    const zipParam = options?.zip ? `&zip=${options.zip}&distance=100` : ''
    const useAPDomain = options?.searchWithinAP ? '&aidomain=ap' : ''
    const {
      data: {
        hits: { total, hits },
      },
    } = await axios.get(
      `${Config.API_GATE_URL}/organizations/aisearch?${searchTerm}${zipParam}&size=10${useAPDomain}`,
      apiGatewayRequestSettings()
    )
    // Filter out any results where the ais list is empty
    const suggestions = hits
      .filter(({ _source: h }) => h.ais.length > 0)
      .map(({ _source: h }) => ({
        orgId: h.org_id,
        orgName: h.org_full_name,
        city: h.org_city,
        state: h.org_state_cd,
        province: h.org_province,
        country: h.org_country_iso_cd,
        address: h.org_street_addr1,
        zip: h.org_zip5,
        postal: h.org_intl_postal_code,
        aiList: h.ais,
      }))
    const filteredTotal = suggestions.length
    return {
      total: filteredTotal,
      suggestions,
    }
  } catch (err) {
    return { suggestions: [], total: 0 }
  }
}

export const getStudentsFromOrg = async ({ orgId, educationPeriodCd, suggestion }) => {
  try {
    const { data } = await axios.get(
      `${
        Config.API_URL
      }/registrations/exams/organizations/${orgId}/education-periods/${educationPeriodCd}/students?studentIdentifier=${encodeURIComponent(
        suggestion
      )}`
    )
    return { suggestions: data, total: data.length }
  } catch (err) {
    return { suggestions: [], total: 0 }
  }
}

export const fetchSchoolsByDICode = async code => {
  try {
    const searchTerm =
      Number.isNaN(parseInt(code, 10)) || code.length !== 4 ? `name=${code}` : `dicode=${code}`
    const {
      data: {
        hits: { total, hits },
      },
    } = await axios.get(
      `${Config.API_GATE_URL}/organizations/disearch?${searchTerm}&ap_pgm=y&size=10`,
      apiGatewayRequestSettings()
    )

    return {
      total,
      suggestions: hits.map(({ _source: h }) => ({
        dicode: h.di_code,
        name: h.org_full_name,
        city: h.org_city,
        state: h.org_state_cd,
        country: h.org_country_iso_cd,
        address: h.org_street_addr1,
        zip: h.org_zip5,
        postal: h.org_intl_postal_code,
      })),
    }
  } catch (err) {
    return { suggestions: [], total: 0 }
  }
}
